import { getTagList, postTag } from "@/services/tag.service";
import { setPaginationDetails } from "../../utils/utils";

  // initial state
  const state = () => ({
 
  });
  
  // mutations
  const mutations = { };
  
  // actions
  const actions = {

    async loadTagList(vuexContext, co) {
      return await getTagList(co).then((response) => {
        let data = response.data.data;
        let items = data.items;
        let totalCount = data.totalCount;
        let totalPages = data.totalPages;
  
        items.map((item, index) => {
          item.index = index + 1;
          item.Name = item.name;
        });
  
        setPaginationDetails(co, totalCount, totalPages);
  
        return items;
      });
    },  

    async postTagModel(vuexContext, data) {
      return await postTag(data)
    },

  };
  
  // getters
  const getters = {};
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
  